<template>
  <section class="py-16 px-4 md:px-8 lg:px-16 bg-white">
    <div class="text-center mb-12">
      <h2 class="text-3xl md:text-4xl font-bold mb-4">{{ themeStore.theme.UpcomingEventSection.title }}</h2>
      <p class="text-text-light max-w-2xl mx-auto">
        {{ themeStore.theme.UpcomingEventSection.subtitle }}
      </p>
    </div>
    <div class="flex justify-center">
      <!-- Event Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 w-full max-w-6xl">
        <div
          v-for="event in themeStore.theme.UpcomingEventSection.cards"
          :key="event.id"
          class="bg-white p-6 rounded-lg shadow-md transform transition-all duration-300 hover:scale-[1.01] hover:shadow-lg cursor-pointer"
          @click="goToEventDetails(event.id)"
        >
          <img
            :src="event.image || 'carousel1'"
            :alt="event.title"
            class="w-full h-40 object-cover rounded-t-lg mb-4"
          />
          <!-- Title and Subtitle Section -->
          <div class="mb-4 border-b border-gray-200 pb-2">
            <h3 class="text-xl font-semibold text-gray-800">{{ event.date }}</h3>
            <p class="text-sm text-text-light">{{ `${event.instructor} | ${event.location}` }}</p>
          </div>
          <!-- Event Details Text -->
          <div class="space-y-2">
            <h4 class="text-lg font-medium text-gray-700">{{ event.title }}</h4>
            <p class="text-sm text-text-light flex items-center gap-2">
              <Clock :size="14" /> {{ event.time }}
            </p>
            <p class="text-sm text-text-light">{{ event.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

const themeStore = useThemeStore();
import { defineProps, computed } from 'vue';
import { Clock } from 'lucide-vue-next';
import { useThemeStore } from '../../stores/themeStore';
import theme from '../../theme';
import carousel1 from '../../assets/carousel1.jpg'

const props = defineProps({
  upcomingEvents: Array,
});

// Default data with 6 events


const eventsToDisplay = computed(() => props.upcomingEvents && props.upcomingEvents.length > 0 ? props.upcomingEvents : defaultEvents);

const goToEventDetails = (id) => {
  console.log(`Navigating to event details for ID: ${id}`);
  alert(`Clicked event: ${eventsToDisplay.value.find(e => e.id === id)?.title}`);
};
</script>

<style scoped>
/* Custom colors to match your theme */
.bg-bright-yellow {
  background-color: #FDB813;
}
.bg-dark-blue {
  background-color: #1E3A8A;
}
.text-text-light {
  color: #6B7280; /* Light gray for text */
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .md\:grid-cols-2 { /* Changed from md:grid-cols-3 to md:grid-cols-2 for better mobile stacking */
    grid-template-columns: 1fr; /* Stack cards on small screens */
  }
  .p-6 {
    padding: 1rem; /* Reduce padding on small screens */
  }
  .text-xl {
    font-size: 1.25rem; /* Slightly smaller title on mobile */
  }
  .text-lg {
    font-size: 1.125rem; /* Adjust subtitle size */
  }
  .text-sm {
    font-size: 0.875rem; /* Adjust detail text size */
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .lg\:grid-cols-3 { /* This targets larger screens, but md:grid-cols-2 will apply first */
    grid-template-columns: repeat(2, minmax(0, 1fr)); /* Two columns on medium screens */
  }
}
</style>
